class CategoriaProducto
{
  idCategoriaProducto = 0;
  nombreCategoria = "";
  activo = true;
  usuario_idUsuario = "";
  accion = "";
  fechahora = "";
  idEmpresa = 0;

  traducciones = null;
  subcategorias = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = CategoriaProducto;
